import * as actions_timeclock from 'actions/timeclock-actions';
import React, { useEffect, useState } from 'react';
import TasksCheckin from './tasks-checkin';
import TimeCardModal from './timecard-modal';
import moment from 'moment';
import { Avatar } from 'enspire-manager-framework';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function TimeClock(props) {

	const params = useParams();
    const dispatch = useDispatch();

    const defaultTask = useSelector((store) => store.settings.settings_tasks.find((task) => task.default));
    const settings = useSelector((store) => store.settings.settings);
    const user = useSelector((store) => store.users.user);
    const users = useSelector((store) => store.users);

    const [viewTasksCheckin, setViewTasksCheckin] = useState(false);
    const [viewTimesheet, setViewTimeCard] = useState(false);
    const [accumulated, setSeconds] = useState(0);
    const [currentTime, setCurrentTime] = useState();

    const timeTotal = moment.utc((accumulated) * 1000);
    const name = user?.firstName + ' ' + user?.lastName;

    /* Effects --------------------------*/

    useEffect(() => {
        const interval = setInterval(() => {
            var seconds = users.time_clock?.secondsAccumulated ?? 0;
            if (users.time_clock?.clockedIn) {
                var newSeconds = moment().diff(moment(users.time_clock?.lastTimeIn.toDate()), 'seconds');
                setSeconds(seconds + newSeconds);
            } else {
                setSeconds(seconds);
            }
            setCurrentTime(moment());
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [users.time_clock?.secondsAccumulated, users.time_clock?.clockedIn]);

    /* Actions --------------------------*/
	
    const handleClockIn = () => {
        if (settings?.timeclock?.taskRequired) {
            setViewTasksCheckin(true)
        } else {
            dispatch(actions_timeclock.clockIn(params.handle, users.user, defaultTask, settings));
        }
	};
	const handleClockOut = () => {
        if (settings?.timeclock?.taskRequired) {
            setViewTasksCheckin(true);
        } else {
            dispatch(actions_timeclock.clockOut(params.handle, users.user));
        }
	};
    
    return (
        <>
            <div className="row mt-3 mb-2 px-3">
                <div className="col-12 py-2" style={{ backgroundColor: '#dddddd', borderRadius: '12px' }}>
                    <div className="row">
                        <div className="col-3">
                            <Avatar className="" bgColor="darkOrange" color="white" size={70} fontSize={'30px'} name={name} image={user.contact?.photoUrl} border={'2px solid white'} />
                        </div>
                        <div className="col-5">
                            <p className="m-0 nowrap" style={{ fontSize: '24px' }}>
                                <i className="far fa-clock mr-2"></i>
                                {currentTime?.format('hh:mm') ?? '00:00'}
                                <span style={{ fontSize: '16px' }}>{currentTime?.format('a')}</span>
                            </p>
                            <p className="mb-3 mt-n2 nowrap" style={{ fontSize: '16px' }}>
                                <span className="" style={{ fontSize: '22px' }}>{ `${timeTotal?.format('H')}h ${timeTotal?.format('mm')}m ${timeTotal?.format('ss')}s` }</span>
                            </p>
                            { users.work_order_checked_in
                                ?   <p className="mb-0 mt-n2" style={{ fontSize: '14px' }}>
                                        { 'WO #' + users.work_order_checked_in.customId }
                                    </p>
                                :   <p className="mb-0 mt-n2 text-muted" style={{ fontSize: '12px' }}>
                                        { users.time_clock?.clockedIn && <>Clocked In: { moment(users.time_clock?.lastTimeIn?.toDate()).format('MMM D [at] h:mm A') }</>}
                                        { !users.time_clock?.clockedIn && <>Clocked Out: { moment(users.time_clock?.lastTimeOut?.toDate()).format('MMM D [at] h:mm A') }</>}
                                    </p>
                            }
                        </div>
                        <div className="col-4">
                            <div>
                                { !users.time_clock?.clockedIn
                                    ?   <button className={ `text-uppercase btn btn-${(users.time_clock?.clockedIn)?'default':'success'} btn-lg btn-block` } onClick={handleClockIn}>
                                            { (settings?.timeclock?.taskRequired)
                                                ?   <i className="fa-solid fa-list fa-lg mr-2"></i>
                                                :   <i className="fa-solid fa-clock fa-lg mr-2"></i>
                                            }
                                            Clock&nbsp;In
                                        </button>
                                    :   <button className={ `text-uppercase btn btn-${(users.time_clock?.clockedIn)?'danger':'default'} btn-lg btn-block` } 
                                            disabled={!users.time_clock?.clockedIn} onClick={handleClockOut}>Clock&nbsp;Out&nbsp;/ Switch&nbsp;Tasks</button>
                                }
                                <button className={ `btn btn-default btn-lg btn-block text-uppercase` } onClick={() => setViewTimeCard(true)}>Time&nbsp;Card</button>
                            </div>
                        </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
            </div>
            { viewTasksCheckin &&
                <TasksCheckin setViewTasksCheckin={ setViewTasksCheckin } />
            }
            { viewTimesheet &&
                <TimeCardModal setViewTimeCard={ setViewTimeCard } />
            }
        </>

    );
};

